import { Options, Vue } from 'vue-class-component';

import _ from 'underscore'
import { host } from '@/api/Conf';
import Modal from "./Modal.vue";
import Header from '@/components/Header.vue'
@Options({
  components: {
    Modal,
    Header
  }
})
export default class SORecom extends Vue {
  items: any = []
  doc: any = {}
  records: any = []
  inOrderM3 = 0
  item: any = {}
  comment = ''
  tac = false;
  IsLoading = false;
  expanded = false
  public openEdit(item: any): void {
    if(!item.Lock){
      this.item = Object.assign({}, item);
      document.querySelector<HTMLElement>('.modal-sorecom').style.display = 'block'
    }
  }
  public closeEdit(): void {
    document.querySelector<HTMLElement>('.modal-sorecom').style.display = 'none'
  }
  public roundDown(value: number): number {
    return Math.floor(value)
  }
  get totalM3(): number {
    let _total = 0;
    this.records.map((dt: any)=>{
      _total += (Number(dt.UnitM3) * (Number(dt.QtySO)))
    })
    return _total
  }
  get totalRecomM3(): number {
    let _total = 0;
    this.records.map((dt: any)=>{
      _total += (Number(dt.UnitM3) * (Number(dt.QtyRecom)))
    })
    return _total
  }

  get totalIncreaseM3(): number {
    let _total = 0;
    this.records.map((dt: any)=>{
      const __total = (Number(dt.UnitM3) * Number(dt.DistIncrease));
      if(__total > 0)
        _total += __total;
    })
    return _total
  }
  get totalDecreaseM3(): number {
    let _total = 0;
    this.records.map((dt: any)=>{
      const __total = (Number(dt.UnitM3) * Number(dt.DistIncrease));
      if(__total < 0)
        _total += __total;
    })
    return _total
  }
  get totalPrioritas(): number {
    let _total = 0;
    this.records.map((dt: any)=>{
      if(dt.Prio == 1){
        _total++;
      }
    })
    return _total
  }
  get recommended(): any {
    return this.records.filter((d: any)=> d.QtyRecom !==0);
  }
  get notRecommended(): any {
    return this.records.filter((d: any)=> d.QtyRecom ===0);
  }

  public round(value: number): string {
    return value.toFixed(2)
  }
  public saveEdit() {
    const index = _.findIndex(this.records, (o: any)=> o.ItemID == this.item.ItemID)
    this.records[index] = this.item
    this.closeEdit()
  }
  public async submit(): Promise<void> {
    // const filter= this.records.filter((data: any)=> {
    //   const QtySOVolume = Number(data.QtySO) * Number(data.UnitM3);
    //   const QtyRecom = Number(data.QtyRecom) * Number(data.UnitM3)
    //   const diff = QtySOVolume - QtyRecom
    //   return Math.abs(diff) > 1
    // })
    const QtySOVolume = this.records.reduce(function (previousValue: any, currentValue: any) {
      return previousValue + (Number(currentValue.QtySO) * Number(currentValue.UnitM3));
    }, 0);
    const QtyRecom = this.records.reduce(function (previousValue: any, currentValue: any) {
      return previousValue + (Number(currentValue.QtyRecom) * Number(currentValue.UnitM3));
    }, 0);
    // !(totalDecreaseM3 <= 2) || !(totalIncreaseM3 >= 2) || !(totalPrioritas > 0)
    if (confirm('Are you sure you want to submit?')) {
      if(!(this.totalDecreaseM3 <= -2) || !(this.totalIncreaseM3 >= 2)) {
        alert('Minimal harus ada penambahan 2 m3 dan pengurangan 2 m3')
      } else if(this.totalPrioritas < 1){
        alert('Minimal harus ada 1 item prioritas')
      } else if(Math.abs(QtySOVolume - QtyRecom) > 1) {
        alert('Selisih QtySO dan QtyRecom hanya boleh 1 m3')
      } else {
        this.IsLoading = true;
        const _items = []
        for(const i in this.records){
          _items.push(`<Item ItemID="${this.records[i].ItemID}" QtySO="${this.records[i].QtySO}" Prio="${this.records[i].Prio}" DistIncrease="${this.records[i].DistIncrease}" DistComment="${this.records[i].DistComment}" RecordID="${this.records[i].RecordID}" />`);
        }
        const text = `
          <Doc ID="${this.doc.DocID}" DistComment="${this.comment}">
              ${_items.join('\n')}
          </Doc>
        `;
        try {
          await this.axios.post(`${host}/api/v1/query`, {
            "q": `Exec USP_AR_SORecomMaster_UpdateByXML @XMLText = '${text}'`,
            "plain": false
          });
          alert('Data submitted successfully');
          window.location.href="/recom";
        } catch (error) {
          alert(error);
        } finally {
          this.IsLoading = false;
        }
      }
    }
  }
  public async mounted(): Promise<void> {
    this.IsLoading = true;
    const response = await this.axios.post(`${host}/api/v1/query`, {
      "q": `Exec USP_AR_SORecomMaster_Query @FromWeb=1, @DocID = ${this.$route.params.id}`,
      "plain": false
    });
    this.items = response.data
    const _records= await _.filter(this.items, (d: any)=>{
      return typeof(d.RecordID)!='undefined'
    })
    const _recordsRecom = _.filter(_records, (d: any)=>{
      return d.QtyRecom > 0
    })
    const _recordsNonRecom = _.filter(_records, (d: any)=>{
      return d.QtyRecom === 0
    })
    const unions = _.union(_recordsRecom, _recordsNonRecom);
    this.records = unions;
    this.doc = response.data[0]
    this.IsLoading = false;
    console.log(this.records)
  }
}